module.exports = __webpack_public_path__ + "img/icon_finish.2ca81193.png";